/**
 * The super-admin org override's wire contract, shared by the browser that sends it and the server
 * that reads it (MAR-427).
 *
 * Both names are spelled ONCE. A header name written out at each call site eventually disagrees with
 * itself, and the failure is silent in the worst possible direction: the reader simply never sees an
 * override and serves the super-admin their own organization's data while the banner says otherwise.
 *
 * The design — why a header and not a cookie, and why not a token claim — is in
 * `server/utils/orgOverride.ts`.
 */

/** The request header that carries the organization id being impersonated. */
export const ORG_OVERRIDE_HEADER = 'x-marcus-org-override'

/** Where the browser keeps the active override between requests. Client state, not server state. */
export const ORG_OVERRIDE_STORAGE_KEY = 'marcus-org-override'
